const ROUTES = {
  agencies: "/agencies",
  agencyId: (id?: string) => `${ROUTES.agencies}/${id}`,
  analytics: "/analytics",
  deal: "/deals/deal",
  dealBilling: (bookingId: string) => `${ROUTES.deal}/${bookingId}/billing`,
  dealId: (id: string) => `${ROUTES.deal}/${id}`,
  deals: "/deals",
  dealsTab: (tab?: string) => `${ROUTES.deals}/${tab}`,
  forgotPassword: "/forgot-password",
  info: "/info",
  login: "/login",
  messages: "/messages",
  messagesConversation: (threadId: string) => `/messages/${threadId}`,
  planning: "/planning",
  profile: "/profile",
  queryError: "/query-error",
  requests: "/requests",
  requestsId: (id: string) => `${ROUTES.requests}/request/${id}`,
  requestsTab: (tab?: string) => `${ROUTES.requests}/${tab}`,
  resource: (id: string | number) => `${ROUTES.resources}/${id}`,
  resources: "/resources",
  users: "/users",
} as const;

export default ROUTES;
